import React, { FC, useEffect, useState } from 'react';
import { Box, Link, Typography, Unstable_Grid2 as Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ExternalShare } from 'api';
import { getAppImage, getImageSrc, validateImageUrl } from 'helpers';
import { APP_IMAGES } from 'app-constants';

import { IMAGE_SIZE } from 'features/admin/constants';

const styles = {
  noImage: {
    position: 'absolute',
    textAlign: 'center',
  },
  rounded: {
    borderRadius: 16,
  },
} as const;

const ShareImage: FC<ExternalShare> = ({ shared_image_url, share_url }) => {
  const { t } = useTranslation();
  const [isValidUrl, setIsValidUrl] = useState<boolean>(false);

  useEffect(() => {
    const validateUrl = async () => {
      const isValid = await validateImageUrl(shared_image_url);
      setIsValidUrl(isValid as boolean);
    };
    void validateUrl();
  }, [shared_image_url]);

  if (!isValidUrl) {
    return (
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{ height: IMAGE_SIZE, width: IMAGE_SIZE, position: 'relative' }}
      >
        <Typography sx={styles.noImage}>{t('admin:noPreview')}</Typography>
        <img
          style={{ height: IMAGE_SIZE, width: IMAGE_SIZE, ...styles.rounded }}
          {...getAppImage(APP_IMAGES.SocialLoading)}
        />
      </Grid>
    );
  }

  return (
    <Link href={share_url} target="_blank">
      <Box sx={{ height: IMAGE_SIZE, width: IMAGE_SIZE, position: 'relative', ...styles.rounded }}>
        <img
          {...getImageSrc(shared_image_url)}
          style={{ height: '100%', width: '100%', borderRadius: '16px' }}
          alt="Share"
        />
      </Box>
    </Link>
  );
};

export default ShareImage;
